// import React from 'react'
// import NavBarSuper from './NavBarSuper'

// const SuperAdminDashboard = ({user}) => {
//   return (
//     <div>
//       <NavBarSuper user={user} />
//     </div>
//   )
// }

// export default SuperAdminDashboard
// ///super-admin/all



// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';
// import api from '../api';

// const AppContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1200px, calc(100% - 32px));
//   margin: 90px auto 30px;

//   @media (max-width: 768px) {
//     width: min(100%, calc(100% - 20px));
//     margin-top: 80px;
//   }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
//   color: #fff;
//   border-radius: 24px;
//   padding: 28px;
//   margin-bottom: 22px;
//   box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 20px;
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 8px;
//   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
//   font-weight: 800;
//   line-height: 1.2;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   line-height: 1.6;
//   font-size: 0.98rem;
// `;

// const ManageTeamButton = styled.button`
//   background: #fff;
//   color: #1d4ed8;
//   border: none;
//   padding: 12px 24px;
//   border-radius: 12px;
//   font-weight: 800;
//   font-size: 1rem;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

//   &:hover {
//     background: #f8fafc;
//     transform: translateY(-2px);
//   }
// `;

// const ContentCard = styled.div`
//   background: rgba(255, 255, 255, 0.96);
//   border-radius: 22px;
//   padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
//   border: 1px solid rgba(148, 163, 184, 0.16);
// `;

// const HeaderRow = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 14px;
//   margin-bottom: 20px;
//   flex-wrap: wrap;
// `;

// const TitleContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 14px;
// `;

// const Title = styled.h2`
//   color: #0f172a;
//   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.6rem);
//   font-weight: 800;
//   margin: 0;
// `;

// const CountBadge = styled.div`
//   padding: 8px 14px;
//   border-radius: 999px;
//   background: #e0ecff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.92rem;
// `;

// const AppraisalGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(2, minmax(0, 1fr));
//   gap: 16px;

//   @media (max-width: 900px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const AppraisalCard = styled.button`
//   width: 100%;
//   padding: 18px;
//   border-radius: 18px;
//   cursor: pointer;
//   transition: all 0.25s ease;
//   text-align: left;
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
  
//   background: ${({ isReady }) => isReady ? '#f0fdf4' : '#fff'};
//   border: 1px solid ${({ isReady }) => isReady ? '#86efac' : '#e2e8f0'};

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
//     border-color: ${({ isReady }) => isReady ? '#22c55e' : '#bfdbfe'};
//   }
// `;

// const TopRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 14px;
//   align-items: flex-start;
//   flex-wrap: wrap;
//   width: 100%;
// `;

// const UserInfo = styled.div`
//   min-width: 0;
// `;

// const UserName = styled.h3`
//   margin: 0 0 8px;
//   color: #0f172a;
//   font-size: 1.05rem;
//   font-weight: 800;
//   line-height: 1.4;
// `;

// const DetailText = styled.p`
//   margin: 4px 0;
//   color: #64748b;
//   font-size: 0.95rem;
//   line-height: 1.5;

//   span {
//     color: #334155;
//     font-weight: 700;
//   }
// `;

// const TagsContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;
//   gap: 8px;
// `;

// const PeriodTag = styled.div`
//   padding: 6px 12px;
//   border-radius: 999px;
//   background: #eff6ff;
//   color: #1d4ed8;
//   font-weight: 700;
//   font-size: 0.85rem;
//   white-space: nowrap;
// `;

// const StatusBadge = styled.div`
//   padding: 6px 12px;
//   border-radius: 999px;
//   background: ${({ isReady }) => isReady ? '#dcfce7' : '#f1f5f9'};
//   color: ${({ isReady }) => isReady ? '#16a34a' : '#64748b'};
//   font-weight: 800;
//   font-size: 0.8rem;
//   display: flex;
//   align-items: center;
//   gap: 6px;
// `;

// const BottomRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 12px;
//   flex-wrap: wrap;
//   width: 100%;
// `;

// const SubmittedText = styled.p`
//   margin: 0;
//   color: #64748b;
//   font-size: 0.9rem;
// `;

// const ViewAction = styled.span`
//   color: ${({ isReady }) => isReady ? '#16a34a' : '#2563eb'};
//   font-weight: 800;
//   font-size: 0.92rem;
// `;

// const StateBox = styled.div`
//   text-align: center;
//   padding: 50px 20px;
//   border-radius: 18px;
//   background: ${({ type }) =>
//     type === 'error' ? '#fef2f2' : type === 'empty' ? '#f8fafc' : '#ffffff'};
//   color: ${({ type }) =>
//     type === 'error' ? '#dc2626' : '#64748b'};
//   border: 1px solid
//     ${({ type }) =>
//       type === 'error' ? '#fecaca' : '#e2e8f0'};
//   font-size: 1rem;
// `;

// /* ================= MAIN COMPONENT ================= */
// const SuperAdminDashboard = ({ user }) => {
//   const [appraisals, setAppraisals] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAppraisals = async () => {
//       try {
//         const response = await api.get('/appraisal/super-admin/all');
//         setAppraisals(response.data.data || []);
//       } catch (err) {
//         setError(
//           err.response?.data?.message || err.message || 'Failed to fetch appraisals'
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAppraisals();
//   }, []);

//   const handleAppraisalClick = (appraisal) => {
//     const appraisalId = appraisal._id;

//     // Safely extract staff userId from the appraisal object
//     const staffUserId = appraisal.userId || 
//                        appraisal.user?._id || 
//                        appraisal.userDetails?._id || 
//                        appraisal.staffId;

//     if (!staffUserId) {
//       console.error("Could not find staff userId for appraisal:", appraisal);
//       alert("Could not determine staff user ID. Please contact admin.");
//       return;
//     }
//     navigate(`/super-admin/appraisal/${appraisalId}`);
//   };

//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />

//       <PageWrapper>
//         <HeroCard>
//           <div>
//             <HeroTitle>Super Admin Dashboard</HeroTitle>
//             <HeroText>
//               Review staff submissions, track appraisal periods, and open each record for full assessment.
//             </HeroText>
//           </div>
//           <ManageTeamButton onClick={() => navigate('/super-admin/team')}>
//             Manage My Team
//           </ManageTeamButton>
//         </HeroCard>

//         <ContentCard>
//           <HeaderRow>
//             <TitleContainer>
//               <Title>Staff Appraisal Submissions</Title>
//               <CountBadge>{appraisals.length} Submission{appraisals.length !== 1 ? 's' : ''}</CountBadge>
//             </TitleContainer>
//           </HeaderRow>

//           {loading ? (
//             <StateBox>Loading appraisals...</StateBox>
//           ) : error ? (
//             <StateBox type="error">Error: {error}</StateBox>
//           ) : appraisals.length > 0 ? (
//             <AppraisalGrid>
//               {appraisals.map((appraisal) => {
//                 const staffInfo = appraisal.userId || appraisal.userDetails || appraisal.user || {};
//                 const staffName = staffInfo.firstName 
//                   ? `${staffInfo.firstName} ${staffInfo.surname || ''}`.trim()
//                   : staffInfo.username || 'Unknown Staff';

//                 const isReady = appraisal.readyToBeScored || false;

//                 return (
//                   <AppraisalCard
//                     key={appraisal._id}
//                     isReady={isReady}
//                     onClick={() => handleAppraisalClick(appraisal)}
//                     type="button"
//                   >
//                     <TopRow>
//                       <UserInfo>
//                         <UserName>{staffName}</UserName>
//                         <DetailText>
//                           <span>Unit:</span> {staffInfo.unit || 'N/A'}
//                         </DetailText>
//                       </UserInfo>

//                       <TagsContainer>
//                         <PeriodTag>{appraisal.appraisalPeriod || 'No Period'}</PeriodTag>
//                         <StatusBadge isReady={isReady}>
//                           {isReady ? '🟢 Ready to Score' : '🟡 Draft'}
//                         </StatusBadge>
//                       </TagsContainer>
//                     </TopRow>

//                     <BottomRow>
//                       <SubmittedText>
//                         Last Updated: {appraisal.updatedAt
//                           ? new Date(appraisal.updatedAt).toLocaleDateString()
//                           : 'N/A'}
//                       </SubmittedText>
//                       <ViewAction isReady={isReady}>
//                         {isReady ? 'Score Appraisal →' : 'View Draft →'}
//                       </ViewAction>
//                     </BottomRow>
//                   </AppraisalCard>
//                 );
//               })}
//             </AppraisalGrid>
//           ) : (
//             <StateBox type="empty">No appraisals found for your team.</StateBox>
//           )}
//         </ContentCard>
//       </PageWrapper>

//       <Footer />
//     </AppContainer>
//   );
// };
///super-admin/all

import React, { useState, useEffect, useMemo } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { 
  FaUsers, FaFileAlt, FaChevronRight, FaCheckCircle, 
  FaUserCog, FaLock, FaArrowLeft, FaUserEdit, FaEye, 
  FaEyeSlash, FaClipboardCheck, FaShieldAlt, FaCrown, 
  FaGlobe, FaChartLine, FaClock, FaCalendarAlt, 
  FaCalendarWeek, FaTrophy, FaEdit, FaTimesCircle, FaHourglassHalf,
  FaSun, FaMoon, FaTimes, FaStar, FaChartPie, FaTasks
} from 'react-icons/fa';
import NavBarSuper from './NavBarSuper';
import Footer from './Footer';
import api from '../api';
import { useTheme } from '../App'; 

const backendUrl = "https://api.stdl.site"; 

/* ================= HELPERS ================= */
const getWeekLabel = (dateInput) => {
  if (!dateInput) return "Unknown Week";
  let date;
  if (dateInput instanceof Date) {
    date = dateInput;
  } else if (typeof dateInput === 'string') {
    const datePart = dateInput.includes('T') ? dateInput.split('T')[0] : dateInput;
    const parts = datePart.split('-'); 
    if (parts.length !== 3) return "Invalid Date";
    date = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  } else {
    return "Invalid Date";
  }
  if (isNaN(date.getTime())) return "Invalid Date";
  const sunday = new Date(date);
  sunday.setDate(date.getDate() - date.getDay());
  const saturday = new Date(sunday);
  saturday.setDate(sunday.getDate() + 6);
  const getWeekNum = (d) => {
    const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
    return Math.ceil((d.getDate() + firstDay) / 7);
  };
  if (sunday.getMonth() === saturday.getMonth()) {
    return `Week ${getWeekNum(saturday)}`;
  } else {
    const nextMonthName = saturday.toLocaleString("default", { month: "long" });
    return `Week ${getWeekNum(sunday)} / ${nextMonthName} Week ${getWeekNum(saturday)}`;
  }
};

/* ================= ANIMATIONS & THEME ================= */
const float = keyframes`0% { transform: translateY(0px) rotate(0deg); } 50% { transform: translateY(-12px) rotate(2deg); } 100% { transform: translateY(0px) rotate(0deg); }`;
const slideUp = keyframes`from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); }`;
const pulseGold = keyframes`0% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.4); } 70% { box-shadow: 0 0 0 12px rgba(251, 191, 36, 0); } 100% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0); }`;
const spinSlow = keyframes`from { transform: rotate(0deg); } to { transform: rotate(360deg); }`;
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const scaleIn = keyframes`from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; }`;

const ThemeWrapper = styled.div`
  --bg-main: ${({ $isDarkMode }) => $isDarkMode ? '#050505' : '#f8fafc'};
  --bg-card: ${({ $isDarkMode }) => $isDarkMode ? '#171717' : '#ffffff'};
  --text-primary: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-secondary: ${({ $isDarkMode }) => $isDarkMode ? '#a1a1aa' : '#64748b'};
  --border-color: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.06)'};
  --admin-gold: #fbbf24;
  --admin-gold-light: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(251, 191, 36, 0.1)' : '#fef3c7'};
  --admin-dark: #0f172a;
  background-color: var(--bg-main); min-height: 100vh; display: flex; flex-direction: column; width: 100%; overflow-x: hidden;
`;

const PageContainer = styled.main`flex: 1; box-sizing: border-box; padding: 120px 40px 80px; transition: margin-left 0.35s ease, width 0.35s ease; @media (max-width: 1024px) { margin-left: 0; width: 100%; padding: 110px 20px 80px; }`;
const InnerWrap = styled.div`width: 100%; max-width: 1600px; margin: 0 auto;`;

/* ================= STYLED COMPONENTS ================= */
const HeroBanner = styled.div`background: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(135deg, #09090b 0%, #1e1b4b 100%)' : 'linear-gradient(135deg, #0f172a 0%, #312e81 100%)'}; border-radius: 24px; padding: 48px; position: relative; overflow: hidden; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); margin-bottom: 40px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 30px; width: 100%; box-sizing: border-box; animation: ${slideUp} 0.5s ease-out forwards; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(251, 191, 36, 0.1)' : 'transparent'}; &::before { content: ""; position: absolute; top: -50px; right: -50px; width: 400px; height: 400px; background: radial-gradient(circle, rgba(251, 191, 36, 0.15) 0%, rgba(251, 191, 36, 0) 70%); border-radius: 50%; animation: ${float} 8s ease-in-out infinite; }`;
const HeroProfile = styled.div`display: flex; align-items: center; gap: 28px; position: relative; z-index: 2; @media (max-width: 576px) { flex-direction: column; align-items: flex-start; gap: 16px; }`;
const AvatarRing = styled.div`width: 96px; height: 96px; border-radius: 24px; padding: 3px; background: linear-gradient(135deg, #fbbf24, #f59e0b); flex-shrink: 0; box-shadow: 0 10px 25px rgba(251, 191, 36, 0.2); img, div { width: 100%; height: 100%; border-radius: 20px; object-fit: cover; background: var(--bg-card); display: grid; place-items: center; color: var(--admin-gold); font-size: 2.5rem; font-weight: 900; }`;
const HeroTextInfo = styled.div`color: white;`;
const SuperBadge = styled.span`display: inline-flex; align-items: center; gap: 8px; background: rgba(251, 191, 36, 0.15); backdrop-filter: blur(8px); padding: 8px 16px; border-radius: 999px; font-size: 0.75rem; font-weight: 900; color: #fbbf24; text-transform: uppercase; margin-bottom: 12px; border: 1px solid rgba(251, 191, 36, 0.3); letter-spacing: 1px;`;
const WelcomeTitle = styled.h1`margin: 0 0 8px; font-size: clamp(1.8rem, 2.5vw, 2.5rem); font-weight: 900; line-height: 1.2;`;
const WelcomeSub = styled.p`margin: 0; color: rgba(255,255,255,0.7); font-size: 1rem; max-width: 550px; line-height: 1.6;`;

const ThemeToggleBtn = styled.button`position: absolute; top: 24px; right: 24px; z-index: 10; background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.15)'}; border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'}; backdrop-filter: blur(8px); color: ${({ $isDarkMode }) => $isDarkMode ? '#fbbf24' : '#f8fafc'}; width: 44px; height: 44px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; cursor: pointer; transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); &:hover { transform: scale(1.15) rotate(15deg); background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.25)'}; } svg { animation: ${({ $isDarkMode }) => $isDarkMode ? spinSlow : 'none'} 10s linear infinite; }`;

const ScorecardGrid = styled.div`display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 24px; margin-bottom: 24px;`;
const ScoreCard = styled.div`background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 20px; padding: 32px 28px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); display: flex; align-items: center; gap: 20px; transition: all 0.3s ease; position: relative; overflow: hidden; ${({ $isPulsing }) => $isPulsing && css` animation: ${pulseGold} 2s infinite; border-color: rgba(251, 191, 36, 0.5); `} &:hover { transform: translateY(-4px); box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); border-color: ${({ highlight }) => highlight || 'var(--border-color)'}; } &::before { content: ""; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; background: ${({ highlight }) => highlight || 'transparent'}; }`;
const IconWrapper = styled.div`width: 64px; height: 64px; border-radius: 16px; background: ${({ bg }) => bg || 'var(--admin-gold-light)'}; color: ${({ color }) => color || 'var(--admin-gold)'}; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; flex-shrink: 0;`;
const ScoreData = styled.div`display: flex; flex-direction: column; width: 100%;`;
const ScoreNumber = styled.div`font-size: 2.5rem; font-weight: 900; color: var(--text-primary); line-height: 1; margin-bottom: 8px; letter-spacing: -1px;`;
const ScoreText = styled.div`font-size: 0.85rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.5px; display: flex; justify-content: space-between; align-items: center;`;
const ProgressBarContainer = styled.div`width: 100%; height: 6px; background: var(--border-color); border-radius: 4px; margin-top: 12px; overflow: hidden;`;
const ProgressFill = styled.div`height: 100%; background: ${({ color }) => color || 'var(--admin-gold)'}; width: ${({ percentage }) => percentage}%; transition: width 1s ease-in-out;`;

/* 🔥 KANBAN ROSTER STYLES 🔥 */
const TripleView = styled.div`display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 24px; animation: ${fadeIn} 0.3s ease; @media (max-width: 1100px) { grid-template-columns: 1fr 1fr; } @media (max-width: 768px) { grid-template-columns: 1fr; }`;
const ListHeader = styled.h3`font-size: 1rem; font-weight: 800; color: ${({ color }) => color || 'var(--text-primary)'}; display: flex; align-items: center; gap: 8px; margin: 0 0 16px 0; padding-bottom: 12px; border-bottom: 1px solid var(--border-color);`;

/* NEW: Clickable closed box for kanban columns */
const CollapsedBox = styled.div`
  background: var(--bg-main);
  border: 1px dashed var(--border-color);
  border-radius: 12px;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 150px;
  &:hover {
    background: var(--admin-gold-light);
    border-color: var(--admin-gold);
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05);
  }
`;

const CompactCard = styled.div`
  background: var(--bg-main); 
  border: 1px solid var(--border-color); 
  padding: 16px; 
  border-radius: 12px; 
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  margin-bottom: 12px; 
  cursor: grab; 
  transition: all 0.2s; 
  &:hover { border-color: var(--admin-gold); transform: translateX(4px); box-shadow: 0 4px 6px rgba(0,0,0,0.05); }
  &:active { cursor: grabbing; opacity: 0.8; transform: scale(0.98); }
`;
const ColumnWrapper = styled.div`
  display: flex; flex-direction: column; height: 100%;
  border-radius: 16px;
  padding: 12px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  transition: background 0.2s;
  ${({ $isDragOver }) => $isDragOver && css`background: rgba(251, 191, 36, 0.05); border: 1px dashed var(--admin-gold);`}
`;
const ScrollableList = styled.div`flex: 1; overflow-y: auto; min-height: 200px; max-height: 450px; padding-right: 8px; &::-webkit-scrollbar { width: 6px; } &::-webkit-scrollbar-track { background: transparent; } &::-webkit-scrollbar-thumb { background: var(--border-color); border-radius: 4px; } &::-webkit-scrollbar-thumb:hover { background: var(--text-secondary); }`;

/* 🔥 MODAL STYLES 🔥 */
const ModalOverlay = styled.div`position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0, 0, 0, 0.75); backdrop-filter: blur(5px); z-index: 99999; display: flex; align-items: center; justify-content: center; animation: ${fadeIn} 0.2s ease-out; padding: 20px; box-sizing: border-box;`;
const ModalContainer = styled.div`background: var(--bg-card); width: 100%; max-width: 900px; max-height: 90vh; border-radius: 20px; border: 1px solid var(--border-color); box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5); display: flex; flex-direction: column; animation: ${scaleIn} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); overflow: hidden;`;
const ModalHeader = styled.div`padding: 24px; border-bottom: 1px solid var(--border-color); display: flex; justify-content: space-between; align-items: center; background: var(--bg-main);`;
const ModalBody = styled.div`padding: 24px; overflow-y: auto; flex: 1; display: flex; flex-direction: column; gap: 24px;`;
const ModalFooter = styled.div`padding: 24px; border-top: 1px solid var(--border-color); display: flex; justify-content: flex-end; align-items: center; gap: 16px; background: var(--bg-main); flex-wrap: wrap;`;

/* 🔥 MODAL METRICS STYLES 🔥 */
const ModalMetricsGrid = styled.div`display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; @media(max-width: 600px){ grid-template-columns: 1fr; }`;
const MetricCard = styled.div`background: var(--bg-main); border: 1px solid var(--border-color); padding: 16px; border-radius: 12px; display: flex; align-items: center; gap: 16px;`;
const MetricIcon = styled.div`width: 48px; height: 48px; border-radius: 12px; background: ${({ bg }) => bg}; color: ${({ color }) => color}; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; flex-shrink: 0;`;
const MetricVal = styled.div`font-size: 1.4rem; font-weight: 900; color: var(--text-primary); line-height: 1;`;
const MetricLabel = styled.div`font-size: 0.75rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; margin-top: 4px;`;

/* NEW: Donut Pie Chart CSS Component */
const DonutChartContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;
const DonutPie = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: conic-gradient(
    ${({ color }) => color} ${({ pct }) => pct}%,
    var(--border-color) ${({ pct }) => pct}% 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  &::before {
    content: '';
    position: absolute;
    width: 48px;
    height: 48px;
    background: var(--bg-main);
    border-radius: 50%;
  }
`;
const DonutLabel = styled.div`
  position: relative;
  z-index: 1;
  font-weight: 900;
  font-size: 0.95rem;
  color: var(--text-primary);
`;

/* 🔥 PREMIUM BAR CHART COMPONENT 🔥 */
const ChartContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  height: 160px;
  padding: 24px 24px 12px;
  background: var(--bg-main);
  border-radius: 16px;
  border: 1px solid var(--border-color);
  margin-bottom: 8px;
  box-shadow: inset 0 2px 10px rgba(0,0,0,0.02);
`;
const BarGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1;
  height: 100%;
  justify-content: flex-end;
  position: relative;
  &:hover .tooltip { opacity: 1; transform: translateY(-10px); }
`;
const BarTrack = styled.div`
  width: 40px;
  height: 100%;
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)'};
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
`;
const BarFill = styled.div`
  width: 100%;
  background: ${({ color }) => color};
  background-image: linear-gradient(180deg, rgba(255,255,255,0.2) 0%, transparent 100%);
  height: ${({ pct }) => pct}%;
  transition: height 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border-radius: 8px;
  box-shadow: 0 -2px 8px ${({ color }) => color}40;
`;
const ChartLabel = styled.span`
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
const ManageTeamButton = styled.button`
  background: #fff;
  color: #1d4ed8;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 800;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #f8fafc;
    transform: translateY(-2px);
  }
`;
const ChartTooltip = styled.div`
  position: absolute;
  top: -30px;
  background: var(--text-primary);
  color: var(--bg-main);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: bold;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  z-index: 10;
  &::after {
    content: ''; position: absolute; bottom: -4px; left: 50%; transform: translateX(-50%);
    border-width: 4px 4px 0; border-style: solid;
    border-color: var(--text-primary) transparent transparent transparent;
  }
`;

/* 🔥 MODAL TABLE STYLES 🔥 */
const StyledTable = styled.table`width: 100%; border-collapse: collapse; text-align: left;`;
const Th = styled.th`padding: 12px 16px; border-bottom: 2px solid var(--border-color); color: var(--text-secondary); font-size: 0.85rem; font-weight: 800; text-transform: uppercase;`;
const Td = styled.td`padding: 16px; border-bottom: 1px solid var(--border-color); color: var(--text-primary); font-size: 0.95rem; vertical-align: top;`;
const GoalTypeBadge = styled.span`padding: 4px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 800; text-transform: uppercase; background: ${({ type, $isDarkMode }) => type === 'monthly' ? ($isDarkMode ? 'rgba(59,130,246,0.2)' : '#dbeafe') : ($isDarkMode ? 'rgba(139,92,246,0.2)' : '#ede9fe')}; color: ${({ type, $isDarkMode }) => type === 'monthly' ? ($isDarkMode ? '#60a5fa' : '#2563eb') : ($isDarkMode ? '#a78bfa' : '#7c3aed')};`;

const SectionCard = styled.div`background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 24px; padding: 32px; margin-bottom: 40px; @media (max-width: 768px) { padding: 24px; }`;
const SectionHeader = styled.div`display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 16px;`;
const SectionTitle = styled.h2`margin: 0; font-size: 1.4rem; font-weight: 900; color: var(--text-primary); display: flex; align-items: center; gap: 12px;`;
const Badge = styled.div`background: var(--admin-gold-light); color: #b45309; padding: 6px 14px; border-radius: 999px; font-weight: 800; font-size: 0.85rem; border: 1px solid rgba(251, 191, 36, 0.3);`;
const CardGrid = styled.div`display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 24px;`;
const ItemCard = styled.div`background: var(--bg-main); border: 1px solid var(--border-color); border-radius: 16px; padding: 24px; display: flex; flex-direction: column; gap: 16px; cursor: pointer; transition: all 0.2s; &:hover { border-color: var(--admin-gold); transform: translateY(-4px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }`;
const CardTop = styled.div`display: flex; justify-content: space-between; align-items: flex-start; gap: 16px;`;
const NameText = styled.h3`margin: 0 0 6px; font-size: 1.15rem; font-weight: 800; color: var(--text-primary);`;
const SubText = styled.p`margin: 2px 0; font-size: 0.9rem; color: var(--text-secondary); span { font-weight: 700; color: var(--text-primary); }`;
const StatusPill = styled.div`padding: 4px 10px; border-radius: 999px; font-size: 0.7rem; font-weight: 800; display: flex; align-items: center; gap: 4px; white-space: nowrap; background: ${({ ready, $isDarkMode }) => ready ? ($isDarkMode ? 'rgba(16,185,129,0.15)' : '#dcfce7') : 'var(--admin-gold-light)'}; color: ${({ ready, $isDarkMode }) => ready ? ($isDarkMode ? '#34d399' : '#059669') : '#b45309'};`;
const CardBottom = styled.div`display: flex; justify-content: space-between; align-items: center; padding-top: 16px; border-top: 1px solid var(--border-color); margin-top: auto;`;
const OutlineBtn = styled.button`background: transparent; color: var(--text-primary); border: 1px solid var(--border-color); border-radius: 10px; padding: 10px 16px; font-weight: 800; font-size: 0.9rem; cursor: pointer; display: flex; justify-content: center; align-items: center; gap: 8px; transition: all 0.2s; &:hover { border-color: var(--admin-gold); background: var(--admin-gold-light); color: #b45309; }`;
const SubmitBtn = styled.button`background: var(--admin-dark); color: white; border: 1px solid rgba(255,255,255,0.1); padding: 12px 24px; border-radius: 10px; font-size: 0.95rem; font-weight: 800; cursor: pointer; transition: all 0.2s; display: flex; align-items: center; gap: 8px; &:hover { background: #000; transform: translateY(-2px); border-color: var(--admin-gold); color: var(--admin-gold); }`;

//Welcome
/* ================= MAIN COMPONENT ================= */
const SuperAdminDashboard = ({ user, setUser }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const [activeView, setActiveView] = useState('dashboard'); 
  const [appraisals, setAppraisals] = useState([]);
  const [allUsers, setAllUsers] = useState([]); 
  const [allGoals, setAllGoals] = useState([]); 
  const [loading, setLoading] = useState(true);

  // Kanban Open/Close State (Default false = boxed view)
  const [openCols, setOpenCols] = useState({ compliant: false, progress: false, action: false });
  const toggleCol = (col) => setOpenCols(prev => ({ ...prev, [col]: !prev[col] }));

  // Modal State for Kanban Quick Appraise View
  const [selectedStaffData, setSelectedStaffData] = useState(null);

  // Drag and Drop Overrides State
  const [localColumnOverrides, setLocalColumnOverrides] = useState({});
  const [dragOverCol, setDragOverCol] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const appRes = await api.get('/appraisal/super-admin/all').catch(err => console.log("Appraisal fetch error:", err.message));
        const usersRes = await api.get('/auth/all-staff').catch(err => console.log("User fetch error:", err.message));
        
        try {
          const goalsRes = await api.get('/goals/super-admin/all');
          if (goalsRes.data.data) {
            setAllGoals(goalsRes.data.data);
          }
        } catch (goalErr) {
          console.error("Goals fetch error:", goalErr.message);
        }

        setAppraisals(appRes?.data?.data || []);
        setAllUsers(usersRes?.data?.data || []);

      } catch (err) { 
        console.error("Data Sync Error:", err);
      } finally { 
        setLoading(false); 
      }
    };
    fetchDashboardData();
  }, []);

  const displayName = `${user?.title?.trim() || ""} ${user?.firstName?.trim() || user?.name || "Admin"}`.trim();
  const initials = (user?.firstName || user?.name || "A").substring(0, 2).toUpperCase();

  // 🔥 CORE METRICS 🔥
  const totalStaff = allUsers.length;
  const totalAppraisals = appraisals.length; 
  const readyCount = appraisals.filter(a => a.readyToBeScored).length;
  const draftCount = totalAppraisals - readyCount; 

  const getStaffAppraisal = (staffId) => {
    return appraisals.find(a => {
      const aUserId = String(typeof a.userId === 'object' ? a.userId?._id : (a.userId || a.user));
      return aUserId === String(staffId);
    });
  };

  const complianceStats = useMemo(() => {
    const now = new Date();
    const currentWeekLabelString = getWeekLabel(now); 
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    const monthlyGoalsStaff = new Set();
    const weeklyGoalsStaffIds = new Set(); 
    const weeklyAchievementsStaffIds = new Set(); 
    const staffAchievementsMap = {}; 

    if (allGoals && allGoals.length > 0) {
      allGoals.forEach(goal => {
        const staffIdStr = String(typeof goal.userId === 'object' ? goal.userId?._id : (goal.userId || goal.user));
        if (!staffIdStr || staffIdStr === 'undefined') return;

        if (goal.type === 'monthly') {
          const goalDate = new Date(goal.createdAt || goal.updatedAt);
          if (goalDate.getMonth() === currentMonth && goalDate.getFullYear() === currentYear) {
            monthlyGoalsStaff.add(staffIdStr);
          }
        }

        if (goal.type === 'weekly') {
          const goalWeek = getWeekLabel(goal.weeklyDeliveryDate || goal.createdAt);
          if (goalWeek.trim().toLowerCase() === currentWeekLabelString.trim().toLowerCase()) {
            weeklyGoalsStaffIds.add(staffIdStr);
            if (goal.achievements && goal.achievements.trim() !== "") {
              weeklyAchievementsStaffIds.add(staffIdStr);
              staffAchievementsMap[staffIdStr] = goal.achievements; 
            }
          }
        }
      });
    }

    return {
      monthlyGoals: monthlyGoalsStaff.size,
      weeklyGoals: weeklyGoalsStaffIds.size,
      weeklyGoalsStaffIds, 
      weeklyAchievements: weeklyAchievementsStaffIds.size,
      weeklyAchievementsStaffIds, 
      staffAchievementsMap,
      currentWeekLabelString 
    };
  }, [allGoals]);

  // 🔥 DRAG AND DROP COLUMN LOGIC 🔥
  const compliantAchievers = allUsers.filter(staff => {
    if (localColumnOverrides[staff._id]) return localColumnOverrides[staff._id] === 'compliant';
    return complianceStats.weeklyAchievementsStaffIds.has(String(staff._id));
  });
  
  const goalsOnlyStaff = allUsers.filter(staff => {
    if (localColumnOverrides[staff._id]) return localColumnOverrides[staff._id] === 'progress';
    return complianceStats.weeklyGoalsStaffIds.has(String(staff._id)) && !complianceStats.weeklyAchievementsStaffIds.has(String(staff._id));
  });

  const pendingStaff = allUsers.filter(staff => {
    if (localColumnOverrides[staff._id]) return localColumnOverrides[staff._id] === 'action';
    return !complianceStats.weeklyGoalsStaffIds.has(String(staff._id));
  });

  const mGoalPct = totalStaff > 0 ? Math.round((complianceStats.monthlyGoals / totalStaff) * 100) : 0;
  const wGoalPct = totalStaff > 0 ? Math.round((complianceStats.weeklyGoals / totalStaff) * 100) : 0;
  const wAchPct = totalStaff > 0 ? Math.round((complianceStats.weeklyAchievements / totalStaff) * 100) : 0;

  // 🔥 DRAG HANDLERS 🔥
  const handleDragStart = (e, staffId) => {
    e.dataTransfer.setData("staffId", staffId);
  };

  const handleDragOver = (e, colId) => {
    e.preventDefault();
    setDragOverCol(colId);
  };

  const handleDragLeave = () => {
    setDragOverCol(null);
  };

  const handleDrop = async (e, targetCol) => {
    e.preventDefault();
    setDragOverCol(null);
    const staffId = e.dataTransfer.getData("staffId");
    
    if (staffId) {
      setLocalColumnOverrides(prev => ({ ...prev, [staffId]: targetCol }));
      // Optional: Add backend call here to sync drag and drop status
    }
  };

  // 🔥 MODAL OPEN HANDLER 🔥
  const openStaffModal = (e, staff) => {
    e.stopPropagation();
    const staffGoals = allGoals.filter(g => {
      const gId = String(typeof g.userId === 'object' ? g.userId?._id : (g.userId || g.user));
      return gId === String(staff._id);
    });
    staffGoals.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    const staffAppraisal = getStaffAppraisal(staff._id);

    // Calculate Modal Metrics
    const totalStaffGoals = staffGoals.length;
    const completedStaffGoals = staffGoals.filter(g => g.achievements && g.achievements.trim() !== "").length;
    const completionRate = totalStaffGoals > 0 ? Math.round((completedStaffGoals / totalStaffGoals) * 100) : 0;

    // Calculate 4-Week Trend Data
    const trendData = [];
    for (let i = 3; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - (i * 7));
      const targetWeekLabel = getWeekLabel(d);
      
      const weekGoals = staffGoals.filter(g => getWeekLabel(g.weeklyDeliveryDate || g.createdAt) === targetWeekLabel);
      const total = weekGoals.length;
      const completed = weekGoals.filter(g => g.achievements && g.achievements.trim() !== "").length;
      
      let color = 'var(--border-color)'; 
      if (total > 0) {
        const pct = completed / total;
        if (pct === 1) color = '#10b981'; 
        else if (pct > 0) color = '#fbbf24'; 
        else color = '#ef4444'; 
      }

      trendData.push({
        label: i === 0 ? 'This Wk' : `Wk -${i}`,
        pct: total > 0 ? Math.round((completed / total) * 100) : 0,
        color,
        tooltip: `${completed} / ${total} Goals`
      });
    }

    setSelectedStaffData({
      staff,
      goals: staffGoals,
      appraisal: staffAppraisal,
      metrics: {
        total: totalStaffGoals,
        completed: completedStaffGoals,
        rate: completionRate,
        trends: trendData
      }
    });
  };

  return (
    <ThemeWrapper collapsed={collapsed} $isDarkMode={isDarkMode}>
      <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      {/* 🔥 QUICK APPRAISE MODAL COMPONENT 🔥 */}
      {selectedStaffData && (
        <ModalOverlay onClick={() => setSelectedStaffData(null)}>
          <ModalContainer onClick={e => e.stopPropagation()}>
            <ModalHeader>
              <div>
                <h2 style={{ margin: '0 0 8px', color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FaUserEdit style={{ color: 'var(--admin-gold)' }} />
                  {selectedStaffData.staff.firstName} {selectedStaffData.staff.surname}
                </h2>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', fontWeight: 600 }}>
                    {selectedStaffData.staff.roles || 'Staff'}
                  </span>
                  {selectedStaffData.appraisal ? (
                    <StatusPill ready={selectedStaffData.appraisal.readyToBeScored} $isDarkMode={isDarkMode} style={{ fontSize: '0.7rem', padding: '4px 8px' }}>
                      {selectedStaffData.appraisal.readyToBeScored ? <><FaCheckCircle size={10}/> Action Required</> : <><FaClock size={10}/> Appraisal Draft</>}
                    </StatusPill>
                  ) : (
                    <span style={{ fontSize: '0.75rem', color: '#ef4444', fontWeight: 700, padding: '4px 8px', background: 'rgba(239, 68, 68, 0.1)', borderRadius: '999px' }}>
                      No Appraisal Record
                    </span>
                  )}
                </div>
              </div>
              <button onClick={() => setSelectedStaffData(null)} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '1.2rem', padding: '8px' }}>
                <FaTimes />
              </button>
            </ModalHeader>
            
            <ModalBody>
              {/* 🔥 MODAL METRICS DASHBOARD WITH PIE CHART 🔥 */}
              <ModalMetricsGrid>
                <MetricCard style={{ flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                  <MetricIcon bg="rgba(59, 130, 246, 0.1)" color="#3b82f6" style={{ marginBottom: '8px' }}><FaTasks /></MetricIcon>
                  <MetricVal>{selectedStaffData.metrics.total}</MetricVal>
                  <MetricLabel>Total Goals Logged</MetricLabel>
                </MetricCard>

                <MetricCard style={{ flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                  <MetricIcon bg="rgba(16, 185, 129, 0.1)" color="#10b981" style={{ marginBottom: '8px' }}><FaCheckCircle /></MetricIcon>
                  <MetricVal>{selectedStaffData.metrics.completed}</MetricVal>
                  <MetricLabel>Completed / Achieved</MetricLabel>
                </MetricCard>

                {/* GRAPHICAL PIE CHART COMPONENT */}
                <MetricCard>
                  <DonutChartContainer>
                    <DonutPie 
                      pct={selectedStaffData.metrics.rate} 
                      color={selectedStaffData.metrics.rate > 70 ? '#10b981' : selectedStaffData.metrics.rate > 30 ? '#fbbf24' : '#ef4444'}
                    >
                      <DonutLabel>{selectedStaffData.metrics.rate}%</DonutLabel>
                    </DonutPie>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <FaChartPie color="var(--admin-gold)" />
                        <span style={{ fontSize: '1.1rem', fontWeight: 900, color: 'var(--text-primary)' }}>Rate</span>
                      </div>
                      <MetricLabel>Overall Completion</MetricLabel>
                    </div>
                  </DonutChartContainer>
                </MetricCard>
              </ModalMetricsGrid>

              {/* 🔥 4-WEEK PERFORMANCE TREND (PREMIUM CSS BAR CHART) 🔥 */}
              <h3 style={{ fontSize: '1rem', color: 'var(--text-primary)', margin: '24px 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaChartLine style={{ color: 'var(--admin-gold)' }}/> 4-Week Performance Trend
              </h3>
              <ChartContainer $isDarkMode={isDarkMode}>
                {selectedStaffData.metrics.trends.map((data, index) => (
                  <BarGroup key={index}>
                    <ChartTooltip className="tooltip">{data.tooltip}</ChartTooltip>
                    <BarTrack $isDarkMode={isDarkMode}>
                      <BarFill pct={data.pct} color={data.color} />
                    </BarTrack>
                    <ChartLabel>{data.label}</ChartLabel>
                  </BarGroup>
                ))}
              </ChartContainer>

              <h3 style={{ fontSize: '1rem', color: 'var(--text-primary)', margin: '24px 0 10px', display: 'flex', alignItems: 'center', gap: '8px', borderBottom: '1px solid var(--border-color)', paddingBottom: '12px' }}>
                <FaFileAlt style={{ color: 'var(--admin-gold)' }}/> Detailed Goal Breakdown
              </h3>

              {selectedStaffData.goals.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '30px', color: 'var(--text-secondary)', background: 'var(--bg-main)', borderRadius: '12px', border: '1px dashed var(--border-color)' }}>
                  <p style={{ margin: 0 }}>No goals have been submitted by this staff member.</p>
                </div>
              ) : (
                <StyledTable>
                  <thead>
                    <tr>
                      <Th>Timeframe</Th>
                      <Th>Type</Th>
                      <Th>Goal Description</Th>
                      <Th>Achievement Logged</Th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedStaffData.goals.map(goal => (
                      <tr key={goal._id}>
                        <Td>
                          <span style={{ fontWeight: 'bold' }}>
                            {goal.type === 'weekly' ? getWeekLabel(goal.weeklyDeliveryDate || goal.createdAt) : new Date(goal.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' })}
                          </span>
                        </Td>
                        <Td>
                          <GoalTypeBadge type={goal.type} $isDarkMode={isDarkMode}>{goal.type}</GoalTypeBadge>
                        </Td>
                        <Td style={{ maxWidth: '250px' }}>
                          <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: '1.4' }}>{goal.description || 'No description provided.'}</p>
                        </Td>
                        <Td style={{ maxWidth: '250px' }}>
                          {goal.achievements ? (
                            <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: '1.4', color: '#10b981', fontStyle: 'italic' }}>
                              <FaCheckCircle size={12} /> {goal.achievements}
                            </p>
                          ) : (
                            <span style={{ color: '#f97316', fontSize: '0.85rem' }}>Pending Submission</span>
                          )}
                        </Td>
                      </tr>
                    ))}
                  </tbody>
                </StyledTable>
              )}
            </ModalBody>
            
            <ModalFooter>
              <OutlineBtn onClick={() => setSelectedStaffData(null)}>Close Overlay</OutlineBtn>
              
              <div style={{ display: 'flex', gap: '12px' }}>
                <OutlineBtn onClick={() => navigate(`/super-admin/goals/${selectedStaffData.staff._id}`)}>
                  View All Goals
                </OutlineBtn>
                
                {selectedStaffData.appraisal && (
                  <SubmitBtn 
                    onClick={() => navigate(`/super-admin/appraisal/${selectedStaffData.appraisal._id}`)}
                    style={{ background: selectedStaffData.appraisal.readyToBeScored ? '#10b981' : 'var(--admin-dark)', borderColor: 'transparent' }}
                  >
                    <FaStar /> {selectedStaffData.appraisal.readyToBeScored ? 'Evaluate Appraisal' : 'View Appraisal File'}
                  </SubmitBtn>
                )}
              </div>
            </ModalFooter>
          </ModalContainer>
        </ModalOverlay>
      )}

      <PageContainer collapsed={collapsed}>
        <InnerWrap>
          {/* ================= HERO BANNER ================= */}
          <HeroBanner $isDarkMode={isDarkMode}>
            <ThemeToggleBtn 
              $isDarkMode={isDarkMode} 
              onClick={toggleTheme ? toggleTheme : () => console.warn('Ensure useTheme exports toggleTheme()')}
              title={`Switch to ${isDarkMode ? 'Light' : 'Dark'} Mode`}
            >
              {isDarkMode ? <FaSun /> : <FaMoon />}
            </ThemeToggleBtn>

            <HeroProfile>
              <AvatarRing>
                {user?.profilePicture ? (
                  <img src={user.profilePicture.startsWith("http") ? user.profilePicture : `${backendUrl}${user.profilePicture}`} alt="Avatar" onError={(e) => e.target.style.display="none"} />
                ) : ( <div>{initials}</div> )}
              </AvatarRing>
              <HeroTextInfo>
                <SuperBadge><FaCrown /> Super Admin Matrix</SuperBadge>
                <WelcomeTitle>
                  {activeView === 'dashboard' ? `Welcome back, ${displayName}` : 'Profile Management'}
                </WelcomeTitle>
                <WelcomeSub>
                  {activeView === 'dashboard' ? 'You have full oversight. Monitor global organization metrics, company-wide appraisals, and total workforce data.' :
                  'Manage your executive-level account configurations securely.'}
                </WelcomeSub>
              </HeroTextInfo>
                              <ManageTeamButton onClick={() => navigate('/super-admin/team')}>
            Manage My Team
          </ManageTeamButton>
            </HeroProfile>
          </HeroBanner>

          {/* ================= DASHBOARD VIEW ================= */}
          {activeView === 'dashboard' && (
            <>
              {/* 🔥 CORE EXECUTIVE SCORECARDS */}
              <ScorecardGrid>
                <ScoreCard highlight="#3b82f6">
                  <IconWrapper bg="rgba(59, 130, 246, 0.1)" color="#3b82f6"><FaGlobe /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : totalStaff}</ScoreNumber><ScoreText>Total Workforce</ScoreText></ScoreData>
                </ScoreCard>

                <ScoreCard highlight="#fbbf24">
                  <IconWrapper bg="var(--admin-gold-light)" color="var(--admin-gold)"><FaFileAlt /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : totalAppraisals}</ScoreNumber><ScoreText>Total Appraisals</ScoreText></ScoreData>
                </ScoreCard>

                <ScoreCard highlight="#f97316">
                  <IconWrapper bg="rgba(249, 115, 22, 0.1)" color="#f97316"><FaEdit /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : draftCount}</ScoreNumber><ScoreText>Drafts / In Progress</ScoreText></ScoreData>
                </ScoreCard>

                <ScoreCard highlight="#10b981" $isPulsing={readyCount > 0}>
                  <IconWrapper bg="rgba(16, 185, 129, 0.1)" color="#10b981"><FaClipboardCheck /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : readyCount}</ScoreNumber><ScoreText>Global Ready</ScoreText></ScoreData>
                </ScoreCard>
              </ScorecardGrid>

              {/* 🔥 SUBMISSION ANALYTICS / COMPLIANCE TRACKING 🔥 */}
              <ScorecardGrid style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>
                <ScoreCard highlight="#0ea5e9" style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '24px' }}>
                  <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
                    <IconWrapper bg="rgba(14, 165, 233, 0.1)" color="#0ea5e9" style={{ width: '48px', height: '48px', fontSize: '1.4rem' }}><FaCalendarAlt /></IconWrapper>
                    <ScoreData>
                      <ScoreNumber style={{ fontSize: '1.8rem', marginBottom: '4px' }}>
                        {loading ? '-' : `${complianceStats.monthlyGoals} / ${totalStaff}`}
                      </ScoreNumber>
                      <ScoreText>Submitted monthly goals <span style={{ color: '#0ea5e9' }}>{mGoalPct}%</span></ScoreText>
                    </ScoreData>
                  </div>
                  <ProgressBarContainer><ProgressFill percentage={mGoalPct} color="#0ea5e9" /></ProgressBarContainer>
                </ScoreCard>

                <ScoreCard highlight="#8b5cf6" style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '24px' }}>
                  <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
                    <IconWrapper bg="rgba(139, 92, 246, 0.1)" color="#8b5cf6" style={{ width: '48px', height: '48px', fontSize: '1.4rem' }}><FaCalendarWeek /></IconWrapper>
                    <ScoreData>
                      <ScoreNumber style={{ fontSize: '1.8rem', marginBottom: '4px' }}>
                        {loading ? '-' : `${complianceStats.weeklyGoals} / ${totalStaff}`}
                      </ScoreNumber>
                      <ScoreText>Submitted {complianceStats.currentWeekLabelString} goals <span style={{ color: '#8b5cf6' }}>{wGoalPct}%</span></ScoreText>
                    </ScoreData>
                  </div>
                  <ProgressBarContainer><ProgressFill percentage={wGoalPct} color="#8b5cf6" /></ProgressBarContainer>
                </ScoreCard>

                <ScoreCard highlight="#10b981" style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '24px' }}>
                  <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
                    <IconWrapper bg="rgba(16, 185, 129, 0.1)" color="#10b981" style={{ width: '48px', height: '48px', fontSize: '1.4rem' }}><FaTrophy /></IconWrapper>
                    <ScoreData>
                      <ScoreNumber style={{ fontSize: '1.8rem', marginBottom: '4px' }}>
                        {loading ? '-' : `${complianceStats.weeklyAchievements} / ${totalStaff}`}
                      </ScoreNumber>
                      <ScoreText>Submitted {complianceStats.currentWeekLabelString} achievements <span style={{ color: '#10b981' }}>{wAchPct}%</span></ScoreText>
                    </ScoreData>
                  </div>
                  <ProgressBarContainer><ProgressFill percentage={wAchPct} color="#10b981" /></ProgressBarContainer>
                </ScoreCard>
              </ScorecardGrid>

              {/* 🔥 UPDATED: MASTER KANBAN ROSTER WITH CLICK-TO-VIEW BOXES 🔥 */}
              <SectionCard>
                <SectionHeader>
                  <SectionTitle><FaTrophy style={{color: '#10b981'}} /> {complianceStats.currentWeekLabelString} Operational Roster</SectionTitle>
                  <Badge>Real-Time Tracking</Badge>
                </SectionHeader>
                
                <TripleView>
                  {/* Column 1: Fully Compliant */}
                  <ColumnWrapper 
                    $isDragOver={dragOverCol === 'compliant'}
                    onDragOver={(e) => handleDragOver(e, 'compliant')}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, 'compliant')}
                  >
                    <ListHeader color="#10b981"><FaCheckCircle /> Fully Compliant ({compliantAchievers.length})</ListHeader>
                    
                    {!openCols.compliant ? (
                      <CollapsedBox onClick={() => toggleCol('compliant')}>
                        <FaEye size={28} color="#10b981" />
                        <span style={{ fontWeight: 900, color: 'var(--text-primary)', fontSize: '1.1rem' }}>{compliantAchievers.length} Staff</span>
                        <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Click to view details</span>
                      </CollapsedBox>
                    ) : (
                      <>
                        <OutlineBtn onClick={() => toggleCol('compliant')} style={{marginBottom: '16px', width: '100%', borderColor: '#10b981', color: '#10b981'}}>
                          <FaEyeSlash /> Hide List
                        </OutlineBtn>
                        <ScrollableList>
                          {compliantAchievers.length === 0 && <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem'}}>No fully compliant staff yet.</p>}
                          {compliantAchievers.map(staff => {
                            const achievementText = complianceStats.staffAchievementsMap[staff._id];
                            const appraisalData = getStaffAppraisal(staff._id);
                            return (
                              <CompactCard 
                                key={staff._id} 
                                draggable="true"
                                onDragStart={(e) => handleDragStart(e, staff._id)}
                                onClick={(e) => openStaffModal(e, staff)}
                              >
                                <div style={{ width: '100%' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <div>
                                      <NameText style={{fontSize: '1rem', margin: 0}}>{staff.firstName} {staff.surname}</NameText>
                                      <SubText style={{fontSize: '0.8rem', margin: 0}}>{staff.roles || 'Staff'}</SubText>
                                    </div>
                                    {appraisalData && (
                                      <StatusPill ready={appraisalData.readyToBeScored} $isDarkMode={isDarkMode}>
                                        {appraisalData.readyToBeScored ? 'Appraise' : 'Draft'}
                                      </StatusPill>
                                    )}
                                  </div>
                                  {achievementText && (
                                    <div style={{fontSize: '0.8rem', color: '#10b981', marginTop: '8px', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: '6px'}}>
                                      <FaCheckCircle size={10} /> {achievementText.length > 40 ? achievementText.substring(0, 40) + '...' : achievementText}
                                    </div>
                                  )}
                                </div>
                              </CompactCard>
                            );
                          })}
                        </ScrollableList>
                      </>
                    )}
                  </ColumnWrapper>

                  {/* Column 2: In Progress (Goals Only) */}
                  <ColumnWrapper
                    $isDragOver={dragOverCol === 'progress'}
                    onDragOver={(e) => handleDragOver(e, 'progress')}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, 'progress')}
                  >
                    <ListHeader color="#f97316"><FaHourglassHalf /> In Progress ({goalsOnlyStaff.length})</ListHeader>
                    
                    {!openCols.progress ? (
                      <CollapsedBox onClick={() => toggleCol('progress')}>
                        <FaEye size={28} color="#f97316" />
                        <span style={{ fontWeight: 900, color: 'var(--text-primary)', fontSize: '1.1rem' }}>{goalsOnlyStaff.length} Staff</span>
                        <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Click to view details</span>
                      </CollapsedBox>
                    ) : (
                      <>
                        <OutlineBtn onClick={() => toggleCol('progress')} style={{marginBottom: '16px', width: '100%', borderColor: '#f97316', color: '#f97316'}}>
                          <FaEyeSlash /> Hide List
                        </OutlineBtn>
                        <ScrollableList>
                          {goalsOnlyStaff.length === 0 && <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem'}}>No staff pending achievements.</p>}
                          {goalsOnlyStaff.map(staff => {
                            const appraisalData = getStaffAppraisal(staff._id);
                            return (
                              <CompactCard 
                                key={staff._id} 
                                draggable="true"
                                onDragStart={(e) => handleDragStart(e, staff._id)}
                                onClick={(e) => openStaffModal(e, staff)}
                              >
                                <div style={{ width: '100%' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <div>
                                      <NameText style={{fontSize: '1rem', margin: 0}}>{staff.firstName} {staff.surname}</NameText>
                                      <SubText style={{fontSize: '0.8rem', margin: 0}}>{staff.roles || 'Staff'}</SubText>
                                    </div>
                                    {appraisalData && (
                                      <StatusPill ready={appraisalData.readyToBeScored} $isDarkMode={isDarkMode}>
                                        {appraisalData.readyToBeScored ? 'Appraise' : 'Draft'}
                                      </StatusPill>
                                    )}
                                  </div>
                                </div>
                              </CompactCard>
                            )
                          })}
                        </ScrollableList>
                      </>
                    )}
                  </ColumnWrapper>

                  {/* Column 3: Action Required (No Goals) */}
                  <ColumnWrapper
                    $isDragOver={dragOverCol === 'action'}
                    onDragOver={(e) => handleDragOver(e, 'action')}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, 'action')}
                  >
                    <ListHeader color="#ef4444"><FaTimesCircle /> Action Required ({pendingStaff.length})</ListHeader>
                    
                    {!openCols.action ? (
                      <CollapsedBox onClick={() => toggleCol('action')}>
                        <FaEye size={28} color="#ef4444" />
                        <span style={{ fontWeight: 900, color: 'var(--text-primary)', fontSize: '1.1rem' }}>{pendingStaff.length} Staff</span>
                        <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Click to view details</span>
                      </CollapsedBox>
                    ) : (
                      <>
                        <OutlineBtn onClick={() => toggleCol('action')} style={{marginBottom: '16px', width: '100%', borderColor: '#ef4444', color: '#ef4444'}}>
                          <FaEyeSlash /> Hide List
                        </OutlineBtn>
                        <ScrollableList>
                          {pendingStaff.length === 0 && <p style={{color: 'var(--text-secondary)', fontSize: '0.9rem'}}>All staff have submitted goals!</p>}
                          {pendingStaff.map(staff => {
                            const appraisalData = getStaffAppraisal(staff._id);
                            return (
                              <CompactCard 
                                key={staff._id} 
                                draggable="true"
                                onDragStart={(e) => handleDragStart(e, staff._id)}
                                onClick={(e) => openStaffModal(e, staff)}
                              >
                                <div style={{ width: '100%' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <div>
                                      <NameText style={{fontSize: '1rem', margin: 0}}>{staff.firstName} {staff.surname}</NameText>
                                      <SubText style={{fontSize: '0.8rem', margin: 0}}>{staff.roles || 'Staff'}</SubText>
                                    </div>
                                    {appraisalData && (
                                      <StatusPill ready={appraisalData.readyToBeScored} $isDarkMode={isDarkMode}>
                                        {appraisalData.readyToBeScored ? 'Appraise' : 'Draft'}
                                      </StatusPill>
                                    )}
                                  </div>
                                </div>
                              </CompactCard>
                            )
                          })}
                        </ScrollableList>
                      </>
                    )}
                  </ColumnWrapper>
                </TripleView>
              </SectionCard>

              {/* GLOBAL APPRAISALS */}
              {/* <SectionCard>
                <SectionHeader>
                  <SectionTitle><FaChartLine style={{color: 'var(--admin-gold)'}} /> Master Appraisals Log</SectionTitle>
                  <Badge>{appraisals.length} Total Records</Badge>
                </SectionHeader>
                <CardGrid>
                  {appraisals.map((appraisal) => {
                    const staffInfo = appraisal.userId || appraisal.user || appraisal.userDetails || {};
                    const isReady = appraisal.readyToBeScored || false;
                    return (
                      <ItemCard key={appraisal._id} onClick={() => navigate(`/super-admin/appraisal/${appraisal._id}`)}>
                        <CardTop>
                          <div>
                            <NameText>{staffInfo.firstName ? `${staffInfo.firstName} ${staffInfo.surname}` : 'Unknown Record'}</NameText>
                            <SubText>Cycle: <span>{appraisal.appraisalPeriod}</span></SubText>
                          </div>
                          <StatusPill ready={isReady} $isDarkMode={isDarkMode}>
                            {isReady ? <><FaCheckCircle/> Action Required</> : <><FaClock/> In Progress</>}
                          </StatusPill>
                        </CardTop>
                        <CardBottom>
                          <SubText style={{fontSize: '0.8rem'}}>Last Sync: {new Date(appraisal.updatedAt).toLocaleDateString()}</SubText>
                          <div style={{color: isReady ? 'var(--accent-green)' : 'var(--admin-gold)', fontWeight: 800, fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '4px'}}>
                            {isReady ? 'Evaluate' : 'View Record'} <FaChevronRight size={10} />
                          </div>
                        </CardBottom>
                      </ItemCard>
                    );
                  })}
                </CardGrid>
              </SectionCard> */}
            </>
          )}

        </InnerWrap>
      </PageContainer>
      <Footer />
    </ThemeWrapper>
  );
};

export default SuperAdminDashboard;